import { useState, useEffect, useRef } from 'react';
import apiConfig from '../config/apiConfig';

function logSecurityEvent(eventType) {
  const token = sessionStorage.getItem('foundations-token') || localStorage.getItem('foundations-token');
  if (!token) return;
  try {
    fetch(`${apiConfig.getBaseUrl()}/api/auth/demo/security-event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ type: eventType }),
    }).catch(() => {});
  } catch { /* fire-and-forget */ }
}

export function useDevToolsDetection(isViewer) {
  const [devToolsOpen, setDevToolsOpen] = useState(false);
  const loggedRef = useRef(false);

  useEffect(() => {
    if (!isViewer) return;

    const check = () => {
      const widthDiff = window.outerWidth - window.innerWidth > 160;
      const heightDiff = window.outerHeight - window.innerHeight > 160;
      const open = widthDiff || heightDiff;
      setDevToolsOpen(open);

      if (open && !loggedRef.current) {
        loggedRef.current = true;
        logSecurityEvent('devtools_open');
      }
    };

    const interval = setInterval(check, 1000);
    check();

    return () => clearInterval(interval);
  }, [isViewer]);

  // Intercept getDisplayMedia for screen capture detection
  useEffect(() => {
    if (!isViewer) return;
    if (!navigator.mediaDevices?.getDisplayMedia) return;

    const original = navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices);
    navigator.mediaDevices.getDisplayMedia = async function (...args) {
      logSecurityEvent('screen_capture_attempt');
      return original(...args);
    };

    return () => {
      navigator.mediaDevices.getDisplayMedia = original;
    };
  }, [isViewer]);

  return devToolsOpen;
}
